<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
        <div class="section-1400 padding-top-40">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <h4 class="mb-3 font-weight-600">RANA National Leadership</h4>
                    <div class="col-12 text-center">
                        <div
                            #swiperContainer
                            class="section swiper-team padding-top-bottom-40 swiper-container-coverflow swiper-container-3d swiper-container-initialized swiper-container-horizontal"
                        >
                            <div class="swiper-wrapper">
                                <div
                                        class="swiper-slide"
                                        *ngFor="let member of committeeMembers"
                                >
                                    <div
                                            class="section bg-white over-hide border-4 img-wrap team-wrap-1"
                                    >
                                        <img class="img" [src]="member.image" [alt]="member.name"/>
                                        <div class="section py-4">
                                            <p class="mb-1 size-14 color-secondary">
                                                {{ member.role }}
                                            </p>
                                            <h6 class="mb-3">{{ member.name }}</h6>
                                            <p class="mb-1 size-14 color-secondary" *ngIf="member.email">
                                                <i class="uil uil-envelope size-20 mx-2"></i>
                                                {{ member.email }}
                                            </p>
                                            <p
                                                    class="mb-1 size-14 color-secondary"
                                                    *ngIf="userGroup !== 'NON_MEMBER' && member.phone"
                                            >
                                                <i class="uil uil-phone size-20 mx-2"></i>
                                                {{ member.phone }}
                                            </p>
                                            <p class="mb-1 size-14 color-secondary" *ngIf="member.location">
                                                <i class="uil uil-location size-20 mx-2"></i>
                                                {{ member.location }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
